import { NgModule } from '@angular/core';
import { SidepanelComponent } from './sidepanel.component';
import { RouterModule } from '@angular/router';
import { HasAccessPipeModule, IsFeatureFlagEnabledPipeModule } from '../../pipes';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { IntegrationsSettingsItemMenuComponent } from './components/integrations-settings-item-menu/integrations-settings-item-menu.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';
import { CdkPortalOutlet } from '@angular/cdk/portal';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
    exports: [
        SidepanelComponent
    ],
    imports: [
        DisableAutocompleteDirectiveModule,
        RouterModule,
        HasAccessPipeModule,
        ReactiveFormsModule,
        CommonModule,
        FontAwesomeModule,
        MatListModule,
        MatExpansionModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        IsFeatureFlagEnabledPipeModule,
        CdkPortalOutlet,
    ],
    declarations: [
        SidepanelComponent,
        IntegrationsSettingsItemMenuComponent,
    ]
})
export class SidepanelModule {

}
